import React from 'react';
import './InfoBox.css';

const InfoBox = () => {
  return (
    <section className="info-box-container">
    <div className="info-box-wrapper">
    <div className="info-box">
      Bought something recently? Share your review!
    </div>
  </div>
</section>

  );
};

export default InfoBox;


